import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { ReturnStoreAddressEmailRenderer } from "./email";
import type { ReturnStoreAddressBlockProps } from "./types";

export function ReturnStoreAddressEditorRenderer(props: ReturnStoreAddressBlockProps) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <ReturnStoreAddressEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
